import React from 'react';
import CountUp from 'react-countup';
import ReactApexChart from 'react-apexcharts';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { cardOptions, performanceData, performanceColumns } from './data';
import { newFetch, POST, GET } from '../../../helpers/fetch';
import { truncateText } from '../../../helpers/general';
import { config } from '../../../config/index';
import './styles.css';
const { SERVER_URL } = config;

import placeholderImage from '../../../assets/images/placeholder.jpg';
import Searchbar from '../../../components/Searchbar';

const generateRandomNumbers = (length, min, max) =>
  Array.from(
    { length },
    () => Math.floor(Math.random() * (max - min + 1)) + min
  );

const PerformanceManagement = ({ history }) => {
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const siteID = parseInt(localStorage.getItem('site'), 10);
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 10,
    page: 0,
  });
  const [sortModel, setSortModel] = React.useState([
    { field: 'id', sort: 'asc' },
  ]);
  const [noOfActiveAssociate, setNoOfActiveAssociate] = React.useState(0);
  const [performance, setPerformance] = React.useState([]);
  const [topAssociates, setTopAssociates] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [totalRows, setTotalRows] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [clients, setClients] = React.useState([]);
  const columns = performanceColumns;

  React.useEffect(() => {
    const { field, sort } = sortModel[0] || {};
    fetchNoOfActiveAssociates();
    fetchTopAssociates();

    fetchPerformance(paginationModel, field, sort);
  }, [sortModel, paginationModel, siteID]);

  React.useLayoutEffect(() => {
    if (performance !== undefined) {
      setData(performance);
      setLoading(false);
    }
  }, [performance]);

  React.useEffect(() => {
    fetchClients();
  }, [clientID]);

  const fetchPerformance = async (pagination, field, sort) => {
    setLoading(true);
    let api_path = `/performance_management/view-all`;
    let response = await newFetch(POST, api_path, {
      field,
      sort,
      page: pagination.page,
      pageSize: pagination.pageSize,
      site_id: siteID,
    });

    if (response.success) {
      const performanceData = response?.data.list || [];
      setPerformance(performanceData);

      const totalRecord = response?.data.total_record || 0;
      setTotalRows(totalRecord);
    }

    setLoading(false);
  };

  const fetchNoOfActiveAssociates = async () => {
    let api_path = `/performance_management/associate-no`;
    let response = await newFetch(POST, api_path, {
      site_id: siteID,
    });

    if (response.success) {
      setNoOfActiveAssociate(response.data?.activeAssociates || 0);
    }
  };

  const fetchTopAssociates = async () => {
    let api_path = `/performance_management/top-associates`;
    let response = await newFetch(POST, api_path, {
      site_id: siteID,
    });

    if (response.success) {
      setTopAssociates(response?.data || []);
    }
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  const handleSearch = (e) => {
    e.preventDefault();

    if (e.target.value) {
      const searchText = e.target.value;

      const filteredPerformance = performance.filter((row) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(searchText.toLowerCase())
        )
      );

      setData(filteredPerformance);
    } else {
      setData(performance);
    }
  };

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  return (
    <div
      className="container-fluid"
      style={{
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '6rem',
      }}
    >
      <div className="border-bottom pb-2 py-2 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4 text-brand">Performance Management</h6>
      </div>
      {clients.enable_performance_management ? (
        <>
          <Row className="my-4">
            <Col lg={8} md={12} sm={12} className="container-one">
              <Row>
                <Col xl={5} lg={5} md={6}>
                  <Card className="card-h-100 rounded-2">
                    <CardBody>
                      <Row className="align-items-center">
                        <Col lg={6} md={6} sm={6}>
                          <span className="text-muted mb-2 d-block text-truncate adjust-fs">
                            No. of Associates
                          </span>
                          <h4 className="mb-3">
                            <span
                              className={
                                'counter-value badge bg-success-subtle text-success'
                              }
                            >
                              <CountUp
                                start={0}
                                end={noOfActiveAssociate}
                                duration={2}
                                separator=""
                              />
                            </span>
                          </h4>
                        </Col>
                        <Col lg={6} md={6} sm={6}>
                          <ReactApexChart
                            options={cardOptions}
                            series={[
                              {
                                data: [
                                  ...generateRandomNumbers(
                                    15,
                                    1,
                                    noOfActiveAssociate
                                  ),
                                ],
                              },
                            ]}
                            type="line"
                            className="apex-charts mb-2"
                            dir="ltr"
                            height={50}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  className="d-flex flex-row justify-content-end"
                >
                  <Searchbar
                    search={(e) => handleSearch(e)}
                    placeholder="Search..."
                  />
                </Col>
                <Col lg={12} md={12} sm={12}>
                  <Box sx={{ width: '100%', fontSize: 16 }} className="mt-3">
                    <DataGrid
                      columns={columns}
                      rows={data}
                      rowCount={totalRows}
                      loading={loading}
                      pageSizeOptions={[10, 20, 30, 40, 50, 80, 100]}
                      paginationModel={paginationModel}
                      paginationMode="server"
                      onPaginationModelChange={setPaginationModel}
                      localeText={{
                        noRowsLabel: 'No associate found.',
                      }}
                      initialState={{
                        pagination: {
                          paginationModel: { page: 0, pageSize: 10 },
                        },
                      }}
                      style={{ minHeight: 100 }}
                      sortModel={sortModel}
                      onSortModelChange={handleSortModelChange}
                      getRowHeight={() => 'auto'}
                      sx={{
                        [`& .${gridClasses.cell}`]: {
                          py: 1,
                        },
                        [`& .${gridClasses.columnHeaderTitle}`]: {
                          fontSize: '14px',
                          fontWeight: 'bold',
                          color: '#6c757d',
                        },
                      }}
                      disableSelectionOnClick
                      isRowSelectable={() => false}
                    />
                  </Box>
                </Col>
              </Row>
            </Col>
            <Col lg={4} md={12} sm={12} className="container-two">
              <h6 className="adjust-fs">Top Associates</h6>
              <Card className="card-h-100 rounded-2 mt-4">
                <CardBody className="top-associates">
                  {topAssociates.map((item, index) => (
                    <Row
                      key={index}
                      className={`align-items-center py-3 ${
                        topAssociates.length !== index + 1 && 'border-bottom'
                      } `}
                    >
                      <Col lg={2} md={2} sm={2} className="text-center">
                        <span className="fs-5 fw-bold text-muted">
                          {index + 1}
                        </span>
                      </Col>
                      <Col lg={7} md={7} sm={7}>
                        <img
                          src={
                            item.image
                              ? `${SERVER_URL}/${item.image}`
                              : placeholderImage
                          }
                          alt="default"
                          className="rounded-circle border me-2"
                          style={{ height: '30px', width: '30px' }}
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = placeholderImage;
                          }}
                        />
                        <span className="fw-semibold text-muted">
                          {truncateText(item.associate_name)}
                        </span>
                      </Col>
                      <Col lg={3} md={3} sm={3}>
                        <span className="badge associate-score p-2 px-4">
                          {item?.score ? (
                            <>
                              <CountUp
                                start={0}
                                end={item?.score}
                                duration={2}
                                separator=""
                              />
                              <span>%</span>
                            </>
                          ) : (
                            '--'
                          )}
                        </span>
                      </Col>
                    </Row>
                  ))}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      ) : (
        <div className="text-muted pt-4">
          The client does not have access to this module.
        </div>
      )}
    </div>
  );
};

export default withRouter(PerformanceManagement);
